
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as echarts from 'echarts';

@Component
export default class BarChart extends Vue {
  @Prop({ required: true }) readonly chartData!: any[];
  // @Prop({ default: null }) readonly yMax!: number | null;
  
  private chart: echarts.ECharts | null = null;
  yMax!: number | null;
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chart) {
      this.chart.dispose();
    }
  }

  @Watch('chartData', { deep: true })
  onChartDataChange() {
    this.updateChart();
  }

  private initChart() {
    const container = this.$refs.chartContainer as HTMLElement;
    this.chart = echarts.init(container);
    this.updateChart();
   
  }

  private updateChart() {
    this.yMax=this.chartData[0].notInSchoolCount+5000
    if (!this.chart || !this.chartData) return;

    // Prepare data
    const xData = this.chartData.map(item => item.district);
    const seriesData = this.chartData.map(item => item.notInSchoolCount);

    const option = {
      textStyle: {
        color: '#fff',
        fontFamily: 'Arial, sans-serif'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        textStyle: {
          color: '#fff',
          fontSize: 14
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: xData,
        axisLabel: {
          color: '#fff',
          fontSize: 14,
          rotate: xData.length > 5 ? 30 : 0, // Rotate labels if many items
          margin: 10
        },
        axisLine: {
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.5)',
            width: 1
          }
        },
        axisTick: {
          show: true
        }
      },
      yAxis: {
        type: 'value',
        min: 0,
        max: this.yMax || 30000, // Use automatic max if not specified
        axisLabel: {
          color: '#fff',
          fontSize: 14
        },
        axisLine: {
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.5)',
            width: 1
          }
        },
        splitLine: {
          lineStyle: {
            color: 'rgba(255, 255, 255, 0.1)'
          }
        }
      },
      series: [{
        name: '未到校学生',
        type: 'bar',
        data: seriesData,
        itemStyle: {
          color: '#1890FF'
        },
        label: {
          show: true,
          position: 'top',
          color: '#fff',
          fontSize: 14,
          formatter: (params: any) => params.value
        },
        barWidth: '40%'
      }]
    };

    this.chart.setOption(option);
  }

  private handleResize() {
    if (this.chart) {
      this.chart.resize();
    }
  }
}
